import { ArrowRight } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { LocalizedLink } from '@/components/LocalizedLink'

interface ServiceCardProps {
  serviceId: string
  imageSrc: string
  title: string
  description: string
}

export function ServiceCard({ serviceId, imageSrc, title, description }: ServiceCardProps) {
  const { t } = useTranslation('common')

  return (
    <LocalizedLink
      to={`servizi/${serviceId}`}
      className="group bg-white rounded-lg overflow-hidden shadow-md hover:shadow-xl transition-shadow duration-normal cursor-pointer h-full relative flex flex-col"
    >
      <div className="absolute top-0 left-0 right-0 h-1 bg-brand-red transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300 origin-left z-10" />

      <div className="relative aspect-video overflow-hidden rounded-t-lg">
        <img
          src={imageSrc}
          alt={title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-normal"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-dark/60 to-transparent" />
      </div>

      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold text-brand-dark mb-2 group-hover:text-brand-red transition-colors">
          {title}
        </h3>
        <p className="text-brand-text flex-grow line-clamp-3">
          {description}
        </p>
        <div className="mt-4 inline-flex items-center gap-2 text-brand-red font-medium">
          <span>{t('buttons.learnMore')}</span>
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </div>
      </div>
    </LocalizedLink>
  )
}
